module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"founding-date":"Data de fundação"},"en-US":{"founding-date":"Founding date"}}')
  delete Component.options._Ctor
}
